import React, { useState, useCallback } from 'react';
import { useForm } from "react-hook-form";

//Bootstrap
import { Container, Row, Col } from 'react-bootstrap';

import TitleLightBold from '../TitleLightBold/TitleLightBold';
import ContactFormItem from '../Contact/ContactFormItem/ContactFormItem';

const suscribeArray = [
    {
        id: "email", type: "text", value: "", placeholder: "Email", change: null, validationRegister: {
            required: "Debe ingresar un email",
            pattern: { value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: "Dirección de correo inválida" }
        }
    }
]

const CustomCarousel = () => {
    const { register, handleSubmit, errors } = useForm();
    const [error, setError] = useState(false);
    const [messageResponse, setMessageResponse] = useState(null);
    const [loading, setLoading] = useState(false);
    // const validationRegister = {
    //     required: "Debe ingresar un email",
    //     pattern: { value: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, message: "Dirección de correo inválida" }
    // }

    const onSubmit = useCallback(async (data) => {
        const formData = new FormData();
        console.log(data)
        formData.append('name', data.suscribeInput);
        setError(false);
        setMessageResponse(null);
        setLoading(true);
        try {
            // const response = await axios.post('http://www.prostringmachine.com/php/sendmail.php', formData);
            const response = {
                data: {
                    error: true,
                    message: "Ocurrió un error inesperado, por favor intentalo más tarde."
                }
            }
            setLoading(false);
            setError(response.data.error);
            setMessageResponse(response.data.message);
        } catch (err) {
            setError(true);
            setMessageResponse(err.message);
            setLoading(false);
        }
    }, []);

    return (
        <Container fluid>
            <div className="pt-5">
                <TitleLightBold textLight="Suscribite y obtené" textBold="todo lo último" boldDisplayBlock={true} titleType="h1" />
            </div>
            <Row className="p-5 justify-content-center text-align-center">
                <Col sm="9" md="8" lg="6" xl="5">
                    <form className="custom-form" onSubmit={handleSubmit(onSubmit)}>
                        {suscribeArray.map(c => {
                            let errorMessage = null;
                            for (const k in errors) {
                                if (k === c.id) {
                                    errorMessage = errors[k].message ? errors[k].message : null;
                                }
                            }
                            return (
                                <React.Fragment key={c.id}>
                                    <ContactFormItem {...c} reference={register} errorMessage={errorMessage} fromContact={true} />
                                </React.Fragment>
                            )
                        })}
                        <div className="form-group mt-5 text-center">
                            <button type="submit" className="btn custom-btn px-3 py-2">
                                {loading ? <div className="spinner">
                                    <div className="bounce1"></div>
                                    <div className="bounce2"></div>
                                    <div className="bounce3"></div>
                                </div> : "Suscribirse"}
                            </button>
                        </div>
                        <div className="text-center">
                            {messageResponse ?
                                error ?
                                    <span className="custom-error-message">{messageResponse}</span>
                                    :
                                    <span className="custom-success-message">{messageResponse}</span>
                                : null}
                        </div>
                    </form>
                </Col>
            </Row>
        </Container>
    );
};

export default CustomCarousel;